import { render, staticRenderFns } from "./BulkTagsActions.vue?vue&type=template&id=60726908"
import script from "./BulkTagsActions.vue?vue&type=script&lang=js"
export * from "./BulkTagsActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports